import { FormFieldTypes } from "../../../data/formFieldType";

export const SGBSCategoryCriteriaData = {
  name: "AdditionalInfo",
  initialState: {
    searchByCriteriaName: "",
    channel: null,
    categoryId: null,
    status: null,
  },
  formFields: [
    {
      id: "searchByCriteriaName",
      lable: "Search by Criteria Name",
      Field_Name: "Search by Criteria Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "searchByCriteriaName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-8 mb-3 pr-0",
      },
    },
    {
      id: "channel",
      lable: "Channel",
      Field_Name: "Channel",
      fieldType: FormFieldTypes.SELECT,
      dataField: "channel",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
    {
      id: "categoryId",
      lable: "Category",
      Field_Name: "Category",
      fieldType: FormFieldTypes.SELECT,
      dataField: "categoryId",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-4",
      },
    },
    {
      id: "status",
      lable: "Status",
      Field_Name: "Status",
      fieldType: FormFieldTypes.SELECT,
      dataField: "status",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-4",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
